export const routes = [
  {
    path: '/dashboard-administrativo',
    component: () => import(/* webpackChunkName: "administrative-dashboard" */ './components/Get'),
    name: 'administrative.dashboard',
    meta: {
      requiresAuth: true
    }
  }
]
